<template>
    <v-container fluid grid-list-lg>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Calendario</h1>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>

            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <FullCalendar ref="fullCalendar" defaultView="dayGridMonth"
                              :plugins="calendarPlugins"
                              :locale="locale"
                              :events="events"
                />
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import FullCalendar from '@fullcalendar/vue'
    import dayGridPlugin from '@fullcalendar/daygrid'
    import esLocale from '@fullcalendar/core/locales/es';
    import moment from 'moment'

    export default {
        name: "index",
        components: {FullCalendar},
        data() {
            return {
                calendarPlugins: [dayGridPlugin],
                locale: esLocale,
                events:[
                    { title: 'event 1', date: '2019-05-01' },
                    { title: 'event 2', date: '2019-05-02' }
                ]
            }
        }
    }
</script>

<style lang='scss'>

    @import '~@fullcalendar/core/main.css';
    @import '~@fullcalendar/daygrid/main.css';

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/calendario/index.vue